
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './AlternateItemsEntity.g';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { Buffer } from 'buffer';

function getProductInfoQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function getProductInfoInput(
  apiConfiguration:
    DataServiceEntities.IAPIConfiguration,
  productIds:
    string
): IDataServiceRequest {
  const query = getProductInfoQuery();
  return query.createDataServiceRequestForOperation(
    'GetProductInfo',
    true,
    DataServiceEntities.ValueExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductDetails' },
    {
      apiConfiguration: apiConfiguration,
      productIds: productIds
    }
  );
}

export function getProductInfoAsync(
  context: IContext,ctx: Msdyn365.IActionContext, productIds:
    string
): AsyncResult<any> {
  const clientId=Buffer.from(ctx.requestContext.app.config.clientId,'utf8').toString('base64'); btoa(ctx.requestContext.app.config.clientId);
  const clientSecret=Buffer.from(ctx.requestContext.app.config.clientSecret,'utf8').toString('base64');
  const resource=Buffer.from(ctx.requestContext.app.config.baseUrl,'utf8').toString('base64');
  const altItemUrl=Buffer.from(ctx.requestContext.app.config.axAlternateItemUrl,'utf8').toString('base64');
  const loginUrl=Buffer.from(`https://login.microsoftonline.com/${ctx.requestContext.app.config.tenentId}/oauth2/token`,'utf8').toString('base64');
  const apiConfiguration:DataServiceEntities.IAPIConfiguration = { ClientId: clientId, ClientSecret: clientSecret, Resource: resource, GrantType:'client_credentials', APIUrl:altItemUrl, LoginUrl: loginUrl};
  const request = getProductInfoInput(apiConfiguration, productIds);
  return callActionOrExecute<any>(request, context.callerContext);
}
